<div class="pagination-wrapper">
  <div class="row w-100 d-flex align-items-center">
    <div class="col-md-6">
      <span class="data d-flex">
        <p>{{ (config.currentPage - 1) * config.itemsPerPage + 1 }}</p>
        <p>-</p>
        <p class="hasSpace">
          {{ (config.currentPage * config.itemsPerPage > tableData.totalcount) ?
          tableData.totalcount : (config.currentPage * config.itemsPerPage) }}
        </p>
        <p class="hasSpace">{{ "Of" | translate }}</p>
        <p class="hasSpace">{{ tableData.totalcount }}</p>
        <p class="hasSpace">{{ "Items" | translate }}</p>
      </span>
    </div>
    <div class="col-md-6">
      <div class="d-flex align-items-center justify-content-end">
        <p-paginator
          [rows]="config.itemsPerPage"
          [totalRecords]="tableData.totalcount"
          [first]="(config.currentPage - 1) * config.itemsPerPage"
          [pageLinkSize]="maxSize"
          (onPageChange)="onPageChange(($event.page ?? 0) + 1)">
        </p-paginator>

        <!-- Input to change items per page -->
        <input
          id="items-per-page"
          class="page-items"
          type="number"
          [maxlength]="1"
          [(ngModel)]="itemsPerPageModel"
          (keyup.enter)="onItemsPerPageChange()" />
      </div>
    </div>
  </div>
</div>
